import React, { Component } from "react";
import  "../index.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import Badge from "react-bootstrap/Badge";

class Experience extends Component {
  render() {
    if (this.props.resumeExperience && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.experience;
      var work = this.props.resumeExperience.map(function (work, i) {
        const technologies = work.technologies;
        const mainTechnologies = work.mainTech;

        let mainTech = mainTechnologies.map((technology, i) => {
          return (
            <Badge style={{color: "white"}} pill className="main-badge mr-2 mb-2" key={i}>
              {technology}
            </Badge>
          );
        });
        let tech = technologies.map((technology, i) => {
          return (
            <Badge style={{color: "white"}} pill className="experience-badge mr-2 mb-2" key={i}>
              {technology}
            </Badge>
          );
        });
        return (
          <VerticalTimelineElement contentStyle={{ background: 'var(--main-color)', color: '#fff', fontSize:"13px" }}
          contentArrowStyle={{ borderRight: '7px solid  var(--main-color)' }}
            className="vertical-timeline-element--work"
            date={work.years}
            iconStyle={{
              background: "var(--main-color)",
              color: "#fff",
              textAlign: "center",
            }}
            icon={<i className="fab fa-angular experience-icon"></i>}
            key={i}
          >
            <div style={{ textAlign: "left", marginBottom: "4px" }}>
              {mainTech}
            </div>

            <h3
              className="vertical-timeline-element-title"
              style={{ textAlign: "left", }}
            >
              {work.title}
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              style={{ textAlign: "left"}}
            >
              {work.company}
            </h4>

          </VerticalTimelineElement>
        );
      });
    }

    return (
      <section id="resume" className="pb-5">
        <div className="col-md-12 mx-auto">
          <div className="col-md-12">
            <h2 class="experience">
                {sectionName}
            </h2>
          </div>
        </div>
        <div className="col-md-8 mx-auto" >
            <div >
          <VerticalTimeline >
            {work}
            <VerticalTimelineElement class="vertical-timeline"
              iconStyle={{
                background: "var(--main-color)",
                color: "#fff",
                textAlign: "center",
              }}
              icon={
                <i className="fas fa-hourglass-start mx-auto experience-icon" ></i>
              }
            />
          </VerticalTimeline>
          </div>
       </div>
      </section>
    );
  }
}

export default Experience;
